import { RightOutlined, SearchOutlined , EditOutlined,PrinterOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Input, PageHeader, Row, Select, Space, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";

import accountService from "../../../api/account.service";
import ProgrammeService from "../../../api/programme.service";
import { CONTRA_VOUCHER_TAG, SUCCESS_STATUS } from "../../../utility/Constants";
import commonUtility from "../../../utility/Utils";
// import AdminBreadCrumb from "../../layout/AdminBreadCrumb";
import PaymentPaidList from "../../payment/PaymentPaidList";
import { PRINT_BASE_URL } from "../../../utility/URL";


/*
import accountService from "../../api/account.service";
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'
import VoucherListView from "../../components/voucher/VoucherListView";
*/
// import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from '../../utility/Constants'
//import commonUtility from "../../utility/Utils";

const { Option } = Select;


const ContraVoucherListView = () => {
    const [form] = Form.useForm();
    const [accountList, setAccountList] = useState([]);
    const [selectedFromDate, setSelectedFromDate] = useState("");
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [selectedTranType, setSelectedTranType] = useState("");
    const [selectedAccountID, setSelectedAccountID] = useState("");

    const [voucherList, setVoucherList] = useState([]);
    const [voucherMasterData, setVoucherMasterData] = useState([]);
    const [voucherDetailData, setVoucherDetailData] = useState([]);

    const [isDataUpdated, setIsDataUpdated] = useState(false);





  

    useEffect(() => {
        setVoucherList([])
        setVoucherMasterData([])
        setVoucherDetailData([])
        const data = {
            // formdata:{ from_date:fromdate,to_date:enddate,account_id:accountid }
            formdata: { tran_type: CONTRA_VOUCHER_TAG}
        }
        accountService.voucherListByTag(data).then((res) => {
            console.log(res)

            if (commonUtility.sanitizeObject(res)) {
                const voucher_data = res.response_data;
                console.log(voucher_data)
                setVoucherList(voucher_data)
                setVoucherMasterData(voucher_data.masterData)
                setVoucherDetailData(voucher_data.detailsData)
            }
            setIsDataUpdated(!isDataUpdated)
        });
    }, []);


    const detailColumn = [
        {
            title: 'A/C',
            dataIndex: 'account_name',
            key: 'account_name',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: 'Dr/Cr',
            dataIndex: 'tran_tag',
            key: 'tran_tag',
        },
    ]

    const columns = [
        {
            title: 'Voucher No',
            dataIndex: ['masterData', 'voucher_no'],
            key: 'voucher_no',


        },
        {
            title: 'Voucher Date',
            dataIndex: ['masterData', 'VoucherDate'],
            key: 'VoucherDate',
        },
        {
            title: 'Tran Type',
            dataIndex: ['masterData', 'tran_type'],
            key: 'tran_type',
        },
        {
            title: 'Narration',
            dataIndex: ['masterData', 'narration'],
            key: 'narration',
        },

        {
            title: "Detail",
            dataIndex: "detailsData",
            //render: (detailsData) =>  detailsData.map((data) => data.account_name).join(),
            render: (detailsData) => {
                return <Table columns={detailColumn} pagination={false} className="voucherDetailTable" dataSource={detailsData} />
            },
        },
        {
            title: 'Action',
            key: 'action',
            render: (selectedObj) => (
              <Space style={{display:'flex',flexDirection:'column'}}>
                <Link to={`/contravoucher/entry/${selectedObj.masterData.vmasterID}`}>
                  <Button htmlType="button" type="ghost" size="small" shape="round"  style={{width:90}} >Edit <EditOutlined /></Button>
                </Link>

                <a href={`${PRINT_BASE_URL}voucher/printpdf/${selectedObj.masterData.vmasterID}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0 }`} target="_blank" rel="noopener noreferrer">
                        <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" style={{width:90}} ><PrinterOutlined /> Print</Button>
                </a>


              </Space>

            ),
          },
    ];



    const expandedRowRender = () => {
        const detailColumns = [
            {
                title: 'A/C',
                // dataIndex: 'account_name',
                dataIndex: ['detailsData', 'account_name'],
                key: 'account_name',
            },
            {
                title: 'Amount',
                //dataIndex: 'amount',
                //dataIndex: 'amount',
                dataIndex: ['detailsData', 'amount'],
                key: 'amount',
            },
            {
                title: 'Dr/Cr',
                //dataIndex: 'tran_tag',
                //dataIndex: 'tran_tag',
                dataIndex: ['detailsData', 'tran_tag'],
                key: 'tran_tag',
            },
        ];
        return <Table columns={detailColumns} dataSource={voucherList.detailsData} pagination={false} />;
    };


    // useEffect(() => {

    //     setVoucherList(voucherListValue)
    //     setVoucherMasterData(voucherMasterDataValue)
    //     setVoucherDetailData(voucherDetailDataValue)

    //     console.log("voucherDetailDataValue", voucherMasterDataValue)
    // }, [isDataUpdatedValue])

    return (
        <div>


  
                {/* <AdminBreadCrumb /> */}

            
                  

           
                        <Table
                            columns={columns}
                            rowKey={list => list.masterData.vmasterID}
                            // expandable={{
                            //   expandedRowRender,
                            //   defaultExpandedRowKeys: ['voucher_no'],
                            // }}
                            dataSource={voucherList}
                            size="small"
                        />

            

                    

    

        </div>


    )
}

export default ContraVoucherListView